module.exports = __webpack_public_path__ + "static/img/Bottom Logo_Black.3e2bcd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/svg/Bottom Logo_Black.svg
// module id = TdyB
// module chunks = 5